module.exports = __webpack_public_path__ + "static/media/Theseus.ffbcb8c6.jpg";